<template>
	<div class="my-balance">
		<div class="my-balance__transaction-history transaction-history">
			<div class="transaction-history__info" v-if="transactions.length">
				<div
					class="transaction-history__info-item transaction-history__info-item_1"
				>
					{{ $t(`Id`) }}
				</div>
				<div
					class="transaction-history__info-item transaction-history__info-item_2"
				>
					{{ $t(`Date`) }}
				</div>
				<div
					class="transaction-history__info-item transaction-history__info-item_3"
				>
					{{ $t(`Type`) }}
				</div>
				<div
					class="transaction-history__info-item transaction-history__info-item_4"
				>
					{{ $t(`Total`) }}
				</div>
				<div
					class="transaction-history__info-item transaction-history__info-item_5"
				>
					{{ $t(`Status`) }}
				</div>
			</div>
			<div class="transaction-history__body" v-if="transactions.length">
				<div
					class="transaction-history__item"
					v-for="transaction in transactions"
					:key="transaction.id"
				>
					<div class="transaction-history__id">
						<span>#{{ transaction.id }}</span>
					</div>
					<div class="transaction-history__date">
						<span>{{ formatDate(transaction.created_at) }}</span>
					</div>
					<div class="transaction-history__type">
						<span>{{ $t(`${transaction.type}`) }}</span>
					</div>
					<div class="transaction-history__price">
						<span>{{
							formatCurrency(
								transaction.sum,
								transaction?.currency?.symbol
							)
						}}</span>
					</div>
					<div
						:class="[
							'transaction-history__status',
							transaction.status.toLowerCase(),
						]"
					>
						<span>{{ $t(`${transaction.status.toLowerCase()}`) }}</span>
					</div>
				</div>
			</div>
			<div v-if="!transactions.length" class="transaction-history__empty _l">
				{{ $t("You don't have any transactions yet.") }}
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

export default {
	components: {},
	name: 'MyBalance',
	props: {
		user: Object,
		minTopupAmount: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			transactions: [],
		};
	},
	computed: {
		...mapGetters('app', ['currencySymbol', 'currencyValue']),
		...mapGetters('modals', ['depositModalIsVisible']),
		...mapGetters('user', ['userBalance']),
		getMinTopupAmount() {
			const minTopup = parseFloat(this.minTopupAmount);
			const currencyVal = parseFloat(this.currencyValue);

			// Check if both values are valid numbers
			if (!isNaN(minTopup) && !isNaN(currencyVal) && currencyVal >= 0) {
				return (minTopup * currencyVal).toFixed(2);
			} else {
				return 'N/A';
			}
		},
	},
	methods: {
		...mapActions('modals', ['openDepositModal']),
		formatDate(timestamp) {
			return moment.unix(timestamp).format('DD.MM.YYYY HH:mm');
		},
		formatCurrency(amount, currency) {
			return `${parseFloat(amount).toFixed(2)}${currency}`;
		},
		fetchTransactionHistory() {
			this.$http
				.get(process.env.VUE_APP_API + `transactions`)
				.then((res) => {
					this.transactions = res.data.payload;
				})
				.catch((error) => {
					if (error.response && error.response.status === 401) {
						this.$emit('open-sign-in');
					}
				});
		},
		back() {
			this.$router.go(-1);
		},
	},
	created() {
		this.fetchTransactionHistory();
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/fonts' as *;
@use '@/assets/styles/components/classes' as *;

.my-balance {
	&__transaction-history {
	}
}

.transaction-history {
	overflow-x: auto;
	&__inner {
	}
	&__info {
		min-width: 860px;
		display: flex;
		align-items: center;
		padding: 10px 15px;
		border-radius: var(--border-radius-primary);
		background-color: rgba(196, 196, 196, 0.3);
		gap: 20px;
		@media (min-width: $md3) {
			min-height: 60px;
		}
		@media (max-width: $md3) {
			padding: 10px;
		}
		&-item {
			flex: 0 1 20%;
			display: flex;
			justify-content: center;
			font-weight: 700;
			line-height: 150%;
			font-family: var(--font-family-inter);
			font-size: 16px;
			color: var(--primary-color);
			text-transform: uppercase;
			&_1 {
			}
			&_2 {
			}
			&_3 {
			}
			&_4 {
			}
			&_5 {
			}
		}
	}
	&__body {
		min-width: 860px;
		display: flex;
		flex-wrap: wrap;
		gap: 4px;
	}
	&__item {
		width: 100%;
		border-bottom: 1px solid rgba(196, 196, 196, 0.3);
		display: flex;
		align-items: center;
		gap: 20px;
		padding: 10px 15px;
		@media (min-width: $md3) {
			min-height: 64px;
		}
		@media (max-width: $md3) {
			padding: 10px;
		}
	}
	&__id,
	&__date,
	&__type,
	&__price,
	&__status {
		flex: 0 1 20%;
		justify-content: center;
		display: flex;
		text-transform: capitalize;
		font-weight: 500;
		font-size: 16px;
		line-height: 150%;
		color: var(--primary-color);
		font-family: var(--font-family-inter);
	}
	&__id {
	}
	&__date {
	}
	&__type {
	}
	&__price {
	}
	&__status {
		text-transform: capitalize;
		span {
		}
		&.success {
			span {
				&:last-child {
					color: var(--success-color);
				}
			}
		}
		&.pending {
			span {
				&:last-child {
					color: var(--pending-color);
				}
			}
		}
		&.error {
			span {
				&:last-child {
					color: var(--error-color);
				}
			}
		}
	}
	&__empty {
	}
}
</style>
